// Build an element from a plant (meili object) — ported from v1's
// makePlantElement. Width (m) -> diameter in plan units (1 unit = 1 cm), a
// lobed canopy, a species label, and the plant's own layer.

import { DEFAULT_FILL_COLOR } from './migrations';
import { speciesLabelKeys } from './model/labels';

// The plan layer a plant belongs on: its (first) Layer value, if the plan has
// a layer with that id — the default layers use their names as ids (v1's
// layers.get). Without `layers`, the raw value.
export function speciesLayer(species, layers) {
  const layer = (Array.isArray(species?.Layer) ? species.Layer[0] : species?.Layer) || null;
  if (!layer || !layers) return layer;
  return layers.some((l) => l.id === layer) ? layer : null;
}

export function makePlantElement(species, x, y, layers) {
  const size = species.Width && species.Width !== 'not specified' ? parseFloat(species.Width) : 1;
  const layer = speciesLayer(species, layers);
  const keys = speciesLabelKeys(species);
  return {
    id: `el-${Date.now()}-${Math.round(x)}-${Math.round(y)}`,
    type: 'ellipse',
    speciesIds: [species.id],
    data: {
      x, y,
      width: (size || 1) * 100,
      height: (size || 1) * 100,
      labels: [{ type: 'species', id: species.id, keys }],
      labelX: 0, labelY: 0,
      fillColor: DEFAULT_FILL_COLOR, strokeColor: null, strokeWidth: null,
      layer: layer || null,
      canopyStyle: 'lobed',
      canopySeed: Math.floor(Math.random() * 100000),
      addedDate: null, removedDate: null,
    },
  };
}

export function plantDiameter(species) {
  const size = species.Width && species.Width !== 'not specified' ? parseFloat(species.Width) : 1;
  return (size || 1) * 100;
}
